export const BASE_SCAN_WAVE = '/api/v1/scanwave';
export const LATEST_SCAN_WAVE = '/api/v1/scanwave/latest';
export const CLOSE_CURRENT_SCAN_WAVE = '/api/v1/scanwave/close-current';
